<template>
  <nav class="c-nav-bar">
    <router-link class="c-nav-bar__link" to="/dashboard" exact @click.native="closeMenu">
      <icon width="18" height="18" name="dashboard"></icon>
      <!-- <span>Dashboard</span> -->
    </router-link>
    <router-link class="c-nav-bar__link" to="/search" @click.native="closeMenu">
      <icon width="18" height="18" name="search"></icon>
      <!-- <span>Search</span> -->
    </router-link>
    <router-link class="c-nav-bar__link" to="/system-status" @click.native="closeMenu">
      <icon width="18" height="18" name="signal"></icon>
      <!-- <span>Status</span> -->
    </router-link>
    <router-link class="c-nav-bar__link" to="/profile/quicklinks" @click.native="closeMenu">
      <icon width="18" height="18" name="link" :fill="false"></icon>
      <!-- <span>Links</span> -->
    </router-link>
    <a class="c-nav-bar__link" :class="{'is-active': isOpen}" @click="toggleMenu">
      <icon width="18" height="18" name="menu"></icon>
      <!-- <span>Menu</span> -->
    </a>
  </nav>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'app-nav-bar',

  computed: {
    ...mapState('navigation',['isOpen','isLinkOpen'])

  },

  methods: {
    toggleMenu() {
      this.$store.dispatch('navigation/toggleMenu');
    },

    closeMenu() {
      this.$store.dispatch('navigation/closeMenu');
      this.$store.dispatch('navigation/closeLinkMenu');
    },
    toggleLinkMenu() {
      this.$store.dispatch('navigation/toggleLinkMenu');
    },
  },
};
</script>

<style lang="scss">
.c-nav-bar {
  background: $colour-nhs-white;
  height: 50px;
  height: calc(50px + env(safe-area-inset-bottom));
  box-shadow: 0px -4px 6px rgba(0, 0, 0, 0.06);
  position: fixed;
  bottom: 0;
  left: 0;
  padding-bottom: 0;
  padding-bottom: env(safe-area-inset-bottom);

  right: 0;
  z-index: 25;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

.c-nav-bar__link {
  overflow: hidden;
  /* outline: 1px solid red; */
  display: block;
  width: 60px;
  text-align: center;
  text-decoration: none;
  font-size: 0.75em;
  padding-top: 1em;

  color: $colour-nhs-mid-grey;
}

.c-nav-bar__link.is-active {
  /* outline: 3px solid red; */
  color: $colour-nhs-bright-blue;
  border-bottom: 3px solid $colour-nhs-bright-blue;
  background: #F5F5F5;
  height: 100%;
}

@media screen and (min-width: 640px) {
  .c-nav-bar {
    display: none;
  }
}
</style>
